"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var lodash_1 = __importDefault(require("lodash"));
var splitHashParams_1 = __importDefault(require("./splitHashParams"));
var filterEmptyKeys = function (obj) { return lodash_1.default.pickBy(obj, function (val, key) { return !!key; }); };
var extractParamsFromHash = function (url) {
    if (url === void 0) { url = ''; }
    var params = querystring_1.default.parse(splitHashParams_1.default(url).queryString);
    // Handles a params object that was extracted from an URL with a trailing `&`,
    // which would result in an empty key/value pair.
    return filterEmptyKeys(params);
};
exports.default = extractParamsFromHash;
